import { AccessGroup } from '../../../vas/business-objects/access-group/access-group.model';
import { ControlType } from '../../../vas/business-objects/control-type/control-type.model';
import { Control } from '../../../vas/business-objects/control/control.model';
import { Form } from '../../../vas/business-objects/form/form.model';
import { Group } from '../../../vas/business-objects/group/group.model';
import { Membership } from '../../../vas/business-objects/membership/membership.model';
import { User } from '../../../vas/business-objects/user/user.model';
import * as actions from './form-manager-page.actions';
import { controlDuplicateReducer } from './reducers/control-duplicate.reducer';
import { controlFormLoadReducer } from './reducers/control-form-load.reducer';
import { controlFormSubControlRemoveReducer } from './reducers/control-form-sub-control-remove.reducer';
import { controlFormSubControlReorderReducer } from './reducers/control-form-sub-control-reorder.reducer';
import { controlFormSubmitReducer } from './reducers/control-form-submit.reducer';
import { controlFormUpdateControlTypeReducer } from './reducers/control-form-update-control-type.reducer';
import { controlRemoveReducer } from './reducers/control-remove.reducer';
import { controlReorderReducer } from './reducers/control-reorder.reducer';
import { formCreateReducer } from './reducers/form-create.reducer';
import { formRemoveReducer } from './reducers/form-remove.reducer';
import { formUpdateReducer } from './reducers/form-update.reducer';
import { groupAttachReducer } from './reducers/group-attach.reducer';
import { groupCopyReducer } from './reducers/group-copy.reducer';
import { groupCreateReducer } from './reducers/group-create.reducer';
import { groupDetachReducer } from './reducers/group-detach.reducer';
import { groupRemoveReducer } from './reducers/group-remove.reducer';
import { groupUpdateReducer } from './reducers/group-update.reducer';
import { loadSuccessReducer } from './reducers/load-success.reducer';
import { subControlFormLoadReducer } from './reducers/sub-control-form-load.reducer';
import { subControlFormSubmitReducer } from './reducers/sub-control-form-submit.reducer';

export interface State {
    account: Account;
    membership: Membership;
    accessGroups: {
        ids: Array<string>;
        entities: {[id: string]: AccessGroup}
    };
    control: {
        ids: Array<string>;
        entities: {[id: string]: Control};
        deleted: Array<Control>;
    };
    controlForm: {
        control: Control
    };
    controlType: {
        ids: Array<string>;
        entities: {[id: string]: ControlType};
        deleted: Array<ControlType>;
    };
    dirty: boolean;
    dirtyIds: {
        forms: Array<string>;
        groups: Array<string>;
        controls: Array<string>;
    };
    form: {
        ids: Array<string>;
        entities: {[id: string]: Form};
        deleted: Array<Form>;
        selected: string;
    };
    group: {
        ids: Array<string>;
        entities: {[id: string]: Group};
        deleted: Array<Group>;
        selected: string;
    };
    loaded: boolean;
    subControlForm: {
        control: Control;
        subControl: Control;
    };
    user: User;
}

export const initialState: State = {
    account: undefined,
    membership: undefined,
    accessGroups: {
        ids: [],
        entities: {}
    },
    control: {
        ids: [],
        entities: {},
        deleted: []
    },
    controlForm: {
        control: undefined
    },
    controlType: {
        ids: [],
        entities: {},
        deleted: []
    },
    dirty: false,
    dirtyIds: {
        forms: [],
        groups: [],
        controls: []
    },
    form: {
        ids: [],
        entities: {},
        deleted: [],
        selected: undefined
    },
    group: {
        ids: [],
        entities: {},
        deleted: [],
        selected: undefined
    },
    loaded: false,
    subControlForm: {
        control: undefined,
        subControl: undefined
    },
    user: undefined
};

// tslint:disable-next-line:only-arrow-functions cyclomatic-complexity
export function reducer(state = initialState, action: actions.Actions): State {
    switch (action.type) {

        // LOAD ---------------------------------------------------------------/
        case actions.LOAD_SUCCESS: {
            return loadSuccessReducer(state, action);
        }

        // GENERAL ------------------------------------------------------------/

        case actions.SUBMIT_FORM_MANAGER_SUCCESS: {
            return {
                ...initialState
            };
        }
        case actions.CANCEL_FORM_MANAGER: {
            return {
                ...initialState
            };
        }
        // FORM ---------------------------------------------------------------/
        case actions.FORM_SELECT: {
            return {
                ...state,
                form: {
                    ...state.form,
                    selected: action.payload.formId ?
                        action.payload.formId :
                        undefined
                }
            };
        }
        case actions.FORM_CREATE: {
            return formCreateReducer(state, action);
        }
        case actions.FORM_UPDATE: {
            return formUpdateReducer(state, action);
        }
        case actions.FORM_REMOVE: {
            return formRemoveReducer(state, action);
        }

        // GROUP --------------------------------------------------------------/

        case actions.GROUP_SELECT: {
            return {
                ...state,
                group: {
                    ...state.group,
                    selected: action.payload.group ?
                        action.payload.group.id :
                        undefined
                }
            };
        }
        case actions.GROUP_CREATE: {
            return groupCreateReducer(state, action);
        }
        case actions.GROUP_UPDATE: {

            return groupUpdateReducer(state, action);
        }
        case actions.GROUP_REMOVE: {
            return groupRemoveReducer(state, action);
        }
        case actions.GROUP_ATTACH: {
            return groupAttachReducer(state, action);
        }
        case actions.GROUP_DETACH: {
            return groupDetachReducer(state, action);
        }
        case actions.GROUP_COPY: {
            return groupCopyReducer(state, action);
        }

        // CONTROL ------------------------------------------------------------/

        case actions.CONTROL_REMOVE: {
            return controlRemoveReducer(state, action);
        }
        case actions.CONTROL_REORDER: {
            return controlReorderReducer(state, action);
        }
        case actions.CONTROL_DUPLICATE: {
            return controlDuplicateReducer(state, action);
        }

        // CONTROL FORM -------------------------------------------------------/

        case actions.CONTROL_FORM_LOAD: {
            return controlFormLoadReducer(state, action);
        }
        case actions.CONTROL_FORM_SUBMIT: {
            return controlFormSubmitReducer(state, action);
        }
        case actions.CONTROL_FORM_CANCEL: {
            return {
                ...state,
                controlForm: {
                    control: undefined
                }
            };
        }
        case actions.CONTROL_FORM_UPDATE: {
            return {
                ...state,
                controlForm: {
                    control: action.payload.control
                }
            };
        }
        case actions.CONTROL_FORM_SUB_CONTROL_REORDER: {
            return controlFormSubControlReorderReducer(state, action);
        }
        case actions.CONTROL_FORM_SUB_CONTROL_REMOVE: {
            return controlFormSubControlRemoveReducer(state, action);
        }
        case actions.CONTROL_FORM_UPDATE_CONTROL_TYPE: {
            return controlFormUpdateControlTypeReducer(state, action);
        }

        // SUB CONTROL FORM ---------------------------------------------------/

        case actions.SUB_CONTROL_FORM_LOAD: {
            return subControlFormLoadReducer(state, action);
        }
        case actions.SUB_CONTROL_FORM_SUBMIT: {
            return subControlFormSubmitReducer(state, action);
        }
        case actions.SUB_CONTROL_FORM_CANCEL: {
            return {
                ...state,
                subControlForm: {
                    control: undefined,
                    subControl: undefined
                }
            };
        }
        case actions.SUB_CONTROL_FORM_UPDATE: {
            return {
                ...state,
                subControlForm: {
                    ...state.subControlForm,
                    subControl: action.payload.control
                }
            };
        }

        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/form-manager-page/form-manager-page.reducer.ts